<template>
  <div class="input-group field-file-input">
    <base64-upload
      :key="refresh"
      :imageSrc="value"
      @change="onChangeImage"
    ></base64-upload>
  </div>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';

// You need a specific loader for CSS files
import Base64Upload from 'vue-base64-upload';

export default {
  mixins: [VueFormGenerator.abstractField],
  components: { Base64Upload },
  data() {
    return {
      refresh: new Date(),
      oldValue: '',
    };
  },
  mounted() {
    this.oldValue = this.value;
  },
  watch: {
    value(change, old) {
      if (change !== old) {
        this.refresh = Date.now();
      }
      if (
        this.value
        && !(
          this.value.indexOf('http') === 0
          || this.value.indexOf('/') === 0
          || this.value.indexOf('data:') === 0
        )
      ) {
        this.value = `data:image/png;base64,${this.value}`;
      }
    },
  },
  computed: {},
  methods: {
    onChangeImage(file) {
      this.value = file.base64;
    },
  },

  beforeDestroy() {},
};
</script>
<style lang="scss">
.field-file-input {
  cursor: pointer;

  > * {
    cursor: pointer;
    width: 100%;
    height: auto;
  }
}
</style>
